import {triggersApi} from '../api';
import {List} from 'immutable';
import RuleMatchInfo from 'records/RuleMatchInfo';
import TrendMatchedItems from 'records/TrendMatchedItems';

export default {
  fetchTrendHistory(ruleId, itemId) {
    return triggersApi.getJson(`/trends/${ruleId}/calls/${itemId}`).then(
      props =>
        new TrendMatchedItems({
          ...props,
          ruleItems: List(props.ruleItems).map(trendHistory => new RuleMatchInfo(trendHistory)),
          antiRuleItems: props.antiRuleItems
            ? List(props.antiRuleItems).map(trendHistory => new RuleMatchInfo(trendHistory))
            : null,
        })
    );
  },

  fetchTrendHistoryPeriod(ruleId, start, end, reference) {
    return triggersApi
      .getJson(`/trends/${ruleId}/period?start=${start}&end=${end}&reference=${reference}`)
      .then(
        props =>
          new TrendMatchedItems({
            ...props,
            ruleItems: List(props.ruleItems).map(trendHistory => new RuleMatchInfo(trendHistory)),
            antiRuleItems: props.antiRuleItems
              ? List(props.antiRuleItems).map(trendHistory => new RuleMatchInfo(trendHistory))
              : null,
          })
      );
  },
};
